import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wego-underconstruction',
  template: `
  <section class="content">
		<div class="col-md-12 text-center">
        <p class="headerror"> 500</p>
          <h3><i class="fa fa-warning text-danger"></i> Oops! Page is Under Construction.</h3>
          <p>
            Please try after some time.
          </p>
		</div>
  </section>
  `,
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})
export class UnderConstructionComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/underconstruction.component.ts